var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weapon-icon-container"},[_c('main-weapon',{attrs:{"weapon-id":_vm.weaponId}}),(_vm.count)?_c('span',{staticClass:"count"},[_vm._v(_vm._s(_vm.count))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }